import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";

import { PasswordForgetLink } from "../PasswordForget";
import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";

const styles = (theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0d47a1 0%, #1565c0 50%, #1976d2 100%)",
    padding: theme.spacing(2),
  },
  container: {
    maxWidth: 400,
  },
  paper: {
    padding: theme.spacing(4),
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(3),
  },
  icon: {
    fontSize: "2.5rem",
    marginRight: theme.spacing(1),
    color: "#0d47a1",
  },
  title: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    color: "#0d47a1",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc",
      },
      "&:hover fieldset": {
        borderColor: "#1976d2",
      },
    },
  },
  submitButton: {
    background: "linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)",
    color: "white",
    padding: theme.spacing(1.5),
    fontSize: "1rem",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "8px",
    marginTop: theme.spacing(1),
    "&:hover": {
      background: "linear-gradient(135deg, #0d3b7f 0%, #1565c0 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 16px rgba(13, 71, 161, 0.3)",
    },
    "&:disabled": {
      background: "#ccc",
      color: "#999",
    },
  },
  error: {
    background: "#ffebee",
    color: "#c62828",
    padding: theme.spacing(1.5),
    borderRadius: "8px",
    marginTop: theme.spacing(1),
    border: "1px solid #ef5350",
  },
  footer: {
    marginTop: theme.spacing(3),
    textAlign: "center",
  },
});

const SignInPageContent = ({ classes }) => (
  <Box className={classes.root}>
    <Container className={classes.container}>
      <Paper className={classes.paper}>
        <Box className={classes.header}>
          <LockIcon className={classes.icon} />
          <Typography className={classes.title}>Entrar</Typography>
        </Box>

        <SignInForm classes={classes} />
      </Paper>

      <Box className={classes.footer}>
        <Typography variant="body2" style={{ marginTop: 12, color: "white" }}>
          <PasswordForgetLink />
        </Typography>
      </Box>
    </Container>
  </Box>
);

const SignInPage = withStyles(styles)(SignInPageContent);

const INITIAL_STATE = {
  email: "",
  password: "",
  error: null,
};

class SignInFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  componentDidMount = () => {
    const email = this.props.match.params.email;
    const password = this.props.match.params.password;
    this.setState({ email, password });
  };

  onSubmit = (event) => {
    const { email, password } = this.state;

    this.props.firebase
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.HOME);
      })
      .catch((error) => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, password, error } = this.state;
    const { classes } = this.props;

    const isInvalid = password === "" || email === "";

    return (
      <form onSubmit={this.onSubmit}>
        <Box className={classes.form}>
          <TextField
            name="email"
            value={email}
            onChange={this.onChange}
            type="email"
            placeholder="E-mail"
            label="E-mail"
            variant="outlined"
            fullWidth
            className={classes.textField}
            autoComplete="email"
          />
          <TextField
            name="password"
            value={password}
            onChange={this.onChange}
            type="password"
            placeholder="Senha"
            label="Senha"
            variant="outlined"
            fullWidth
            className={classes.textField}
            autoComplete="current-password"
          />
          <Button
            disabled={isInvalid}
            type="submit"
            className={classes.submitButton}
            variant="contained"
            fullWidth
          >
            Entrar
          </Button>

          {error && (
            <Box className={classes.error}>
              <Typography variant="body2">{error.message}</Typography>
            </Box>
          )}
        </Box>
      </form>
    );
  }
}

const SignInForm = compose(withRouter, withFirebase, withStyles(styles))(SignInFormBase);

export default SignInPage;

export { SignInForm };
